import {
  Navbar,
  MissionSection,
  ProjectsSection,
  Testimonials,
  Resources,
} from "../App.js";
import homepageImage from "../assets/homepage.jpg";
//import communityImage from "../assets/Community.jpg";
import eventsImage from "../assets/events.jpg";

export default function VisitorPage() {
  return (
    <div className="h-full w-screen">
      <Navbar />
      <div className="flex flex-col justify-center items-center mx-[10%]">
        {/* Mission Section */}
        <MissionSection />

        {/* Existing Sections */}
        <ProjectsSection
          header="Projects"
          para="We have completed various projects in the past. Our projects are always successful and we are proud of them."
          btnName="View Projects"
          imagePath={homepageImage}
          imageFirst={true}
        />
        <ProjectsSection
          header="Events"
          para="Join us for memorable gatherings and community activities. Check out our upcoming events that bring our batch together and strengthen our bonds."
          btnName="View Events"
          imagePath={eventsImage}
          linkTo="/events"
        />
        <Testimonials />
        <Resources />
      </div>
    </div>
  );
}
